export default "__VITE_ASSET__YQAAMNe$__"